var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "span",
    [
      _c(
        "a",
        {
          staticClass: "button is-outlined text-sm lg:text-xs",
          attrs: { title: "Edit" },
          on: {
            click: function($event) {
              _vm.showingModal = true
            }
          }
        },
        [_c("i", { staticClass: "far fa-edit" })]
      ),
      _vm._v(" "),
      _vm.showingModal
        ? _c(
            "modal",
            {
              attrs: { title: _vm.title, width: "800px" },
              on: {
                close: function($event) {
                  _vm.showingModal = false
                }
              }
            },
            [
              _c("h2", { staticClass: "title is-3" }, [
                _vm._v(_vm._s(_vm.suiteDetails.company.name))
              ]),
              _vm._v(" "),
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.suiteDetails.company.name,
                      expression: "suiteDetails.company.name"
                    }
                  ],
                  staticClass: "columns"
                },
                [
                  _c("div", { staticClass: "column is-3" }, [
                    _c("div", { staticClass: "field" }, [
                      _c(
                        "label",
                        { staticClass: "image is-square show-icon-hover" },
                        [
                          _c(
                            "span",
                            { staticClass: "icon icon-right is-medium" },
                            [
                              _c("i", {
                                staticClass: "fas fa-pen-square fa-2x"
                              })
                            ]
                          ),
                          _vm._v(" "),
                          _vm.suiteDetails.company
                            ? _c("img", {
                                staticClass: "company-logo",
                                attrs: {
                                  src: _vm.fixHttpProtocol(
                                    _vm.suiteDetails.company.logo_path
                                  )
                                }
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          _c("input", {
                            ref: "newCompanyLogo",
                            staticStyle: { display: "none" },
                            attrs: { type: "file" },
                            on: {
                              change: function($event) {
                                return _vm.uploadLogo(
                                  _vm.$refs.newCompanyLogo.files[0],
                                  _vm.suiteDetails.company
                                )
                              }
                            }
                          })
                        ]
                      )
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "column" }, [
                    _c("div", { staticClass: "field" }, [
                      _c("div", { staticClass: "label" }, [
                        _vm._v("Description")
                      ]),
                      _vm._v(" "),
                      _c("textarea", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.suiteDetails.company.description,
                            expression: "suiteDetails.company.description"
                          }
                        ],
                        staticClass: "textarea",
                        domProps: {
                          value: _vm.suiteDetails.company.description
                        },
                        on: {
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.$set(
                              _vm.suiteDetails.company,
                              "description",
                              $event.target.value
                            )
                          }
                        }
                      })
                    ])
                  ])
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                [
                  _c("h5", {
                    staticClass: "title is-5",
                    domProps: {
                      textContent: _vm._s(_vm.suiteOrTeam + " Details")
                    }
                  }),
                  _vm._v(" "),
                  _c("edit-suite", {
                    attrs: {
                      isAdmin: true,
                      suite: _vm.suiteDetails,
                      companyContacts: _vm.companyContacts,
                      companyId: _vm.suiteDetails.company.maxxId
                    },
                    on: {
                      syncContacts: function($event) {
                        return _vm.fetchCompanyStaff(
                          _vm.suiteDetails.company.maxxId
                        )
                      }
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _vm.noMaxxUser
                ? _c(
                    "b-notification",
                    {
                      staticClass: "is-small",
                      attrs: {
                        type: "is-danger",
                        "has-icon": "",
                        closable: false,
                        role: "alert"
                      }
                    },
                    [
                      _vm._v(
                        "\n      Could not retrieve contacts from MatrixMaxx. Your session may have\n      expired. Please login to fix this.\n    "
                      )
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "buttons is-right w-full",
                  attrs: { slot: "footer" },
                  slot: "footer"
                },
                [
                  _c(
                    "button",
                    {
                      staticClass: "button is-success text-sm lg:text-base",
                      class: { "is-loading": _vm.loading },
                      on: { click: _vm.saveSuite }
                    },
                    [_vm._v("\n        Save\n      ")]
                  ),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass: "button is-success text-sm lg:text-base",
                      class: { "is-loading": _vm.loading },
                      on: { click: _vm.saveSuiteAddAnother }
                    },
                    [_vm._v("\n        Save / Add Another\n      ")]
                  ),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass: "button text-sm lg:text-base",
                      on: {
                        click: function($event) {
                          _vm.showingModal = false
                        }
                      }
                    },
                    [_vm._v("\n        Cancel\n      ")]
                  )
                ]
              )
            ],
            1
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-1ef7808b", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1ef7808b","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/shared/ModalEditSuite.vue
// module id = null
// module chunks = 